<template>
<div class="flex client-dashboard-grid flex-col lg:flex-row gap-2 mb-4 bg-white lg:gap-4">
      <div class="flex flex-col items-start justify-start gap-4 w-full lg:w-[25%]">

      <template v-if="showInventory">
        <TitlePrimary :title="$t('dashboard.titles.inventory')" :icon="InventoryIcon" class="text-[#fff] w-full md:w-auto" />
        <div class="flex flex-wrap justify-center md:justify-start items-start w-full pt-4 pb-4 px-2 md:px-0  gap-2 ">
          <!-- Cada tarjeta muestra el total de la tabla que abre (correo de ADS del 12-10-2026). -->
          <RouterLink to="/client-admin">
            <cardCount :title="$t('dashboard.cards.administrators')" :content="items.total_users" />
          </RouterLink>
          <RouterLink to="/Property?type=comunidad">
            <cardCount :title="$t('dashboard.cards.properties')" :content="items.total_properties" />
          </RouterLink>
          <!-- Inmuebles oculto por decisión del 13-10-2026: Comunidades cuenta solo la cartera horizontal
               y la vertical (`total_estates`, que el back sigue devolviendo) no se muestra en el Inicio.
               Para reponerla, descomentar esta tarjeta. -->
          <!-- <RouterLink to="/Property?type=inmueble">
            <cardCount :title="$t('dashboard.cards.estates')" :content="items.total_estates" />
          </RouterLink> -->
          <RouterLink to="/luz">
            <cardCount :title="$t('dashboard.cards.light')" :content="items.total_light" />
          </RouterLink>
          <RouterLink to="/gas">
            <cardCount :title="$t('dashboard.cards.gas')" :content="items.total_gas" />
          </RouterLink>
          <RouterLink to="/request">
            <cardCount :title="$t('dashboard.cards.incidents')" :content="items.total_requests" />
          </RouterLink>
          <RouterLink to="/supply-bill">
            <cardCount :title="$t('dashboard.cards.invoices')" :content="items.total_invoicces" />
          </RouterLink>
        </div>
      </template>

      <template v-else >
          <TitlePrimary :title="$t('dashboard.titles.create_request')" :icon="DocumentIcon" class="text-[#fff] w-full md:w-auto" />
          <div class="flex flex-col justify-center items-start w-full pt-4 px-2 md:justify-start md:px-0 gap-4 pb-4 button-list">
            <RouterLink to="/forms/supplies" class="w-full">
              <ButtonWhite class="w-full">{{ $t('dashboard.buttons.add-supplies') }}</ButtonWhite>
            </RouterLink>
            <RouterLink to="/forms/invoice" class="w-full">
              <ButtonWhite class="w-full">{{ $t('dashboard.buttons.invoice-form') }}</ButtonWhite>
            </RouterLink>
            <RouterLink to="/forms/change_ownership" class="w-full">
              <ButtonWhite class="w-full">{{ $t('dashboard.buttons.change-ownership') }}</ButtonWhite>
            </RouterLink>
            <!-- Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla. -->
            <!-- <RouterLink to="/forms/change_supplier" class="w-full">
              <ButtonWhite class="w-full">{{ $t('dashboard.buttons.change-supplier') }}</ButtonWhite>
            </RouterLink> -->
            <RouterLink to="/forms/account_change" class="w-full">
              <ButtonWhite class="w-full">{{ $t('dashboard.buttons.account-change') }}</ButtonWhite>
            </RouterLink>
            <RouterLink to="/forms/other_type" class="w-full">
              <ButtonWhite class="w-full">{{ $t('dashboard.buttons.other-types') }}</ButtonWhite>
            </RouterLink>
          </div>
      </template>

    </div>

    <div class="flex flex-col items-start justify-start gap-4 lg:py-0 w-full lg:w-[80%]">
      <TitlePrimary :title="$t('dashboard.titles.request_status')" :icon="OkIcon" class="text-[#fff] w-full md:w-auto" />
      <div class="flex justify-center lg:justify-start items-start w-full pt-4 px-2 mb-4 lg:flex-row md:px-0 flex-wrap gap-4">
        <stateRequest borderColor='#7CADB9' :percentage="requestStats.porcentajeNuevas" :mine="ownRequestsOnly" statusFilter="created">
          {{ $t('dashboard.status.created') }}
        </stateRequest>
        <stateRequest borderColor='#B3DDE8' :percentage="requestStats.porcentajeEnProgreso" :mine="ownRequestsOnly" statusFilter="review">
          {{ $t('dashboard.status.review') }}
        </stateRequest>
        <stateRequest borderColor='#3E7C94' :percentage="requestStats.porcentajePendientes" :mine="ownRequestsOnly" statusFilter="pending">
          {{ $t('dashboard.status.pending') }}
        </stateRequest>
        <stateRequest borderColor='#385660' :percentage="requestStats.porcentajeCerradas" :mine="ownRequestsOnly" statusFilter="results">
          {{ $t('dashboard.status.results') }}
        </stateRequest>
        <stateRequest borderColor='#FF6B6B' :percentage="requestStats.porcentajeCanceladas" :mine="ownRequestsOnly" statusFilter="cancel">
          {{ $t('dashboard.status.cancel') }}
        </stateRequest>
      </div>
    </div>
  </div>
  <div class="pt-4">
    <div class="flex flex-col md:flex-row justify-between gap-4">
      <TitlePrimary :title="$t('dashboard.titles.latest_news')" :icon="RolebackIcon" class="text-[#fff] w-full sm:w-auto" />
      <ButtonWhite v-if="canPublishNews"
        class="flex w-full sm:w-auto items-center justify-center gap-2 duration-500 hover:scale-105 active:scale-100" @click="openModal">
        {{ images.length === 0 ? $t('dashboard.buttons.publish-news') : $t('dashboard.buttons.edit-news') }}
        <EditIcon />
      </ButtonWhite>
    </div>
    <div class="flex justify-center items-center w-full py-4 md:px-0">
      <ImageCarousel :images="images.map(image => image.url)" @delete-image="handleDeleteImage" />
    </div>
  </div>
  <ModalImage v-if="canPublishNews" :isOpen="isModalOpen" v-model:src="selectedImage" :title="$t('modal.title')" :text="$t('modal.text', { max: NEWS_IMAGE_MAX_MB })"
    :accept="NEWS_IMAGE_TYPES.join(',')" :buttons="buttons" @update:src="handleImageSelected" />
</template>

<script setup>
import TitlePrimary from '@/components/title/title-primary.vue';
import stateRequest from '@/components/cards/state-request.vue';
import ImageCarousel from '@/components/carousel/ImageCarousel.vue';
import RolebackIcon from '@/assets/svg/RolebackIcon.vue';
import OkIcon from '@/assets/svg/OkIcon.vue';
import ButtonWhite from '@/components/button/ButtonWhite.vue';
import cardCount from '@/components/cards/cardCount.vue';
import InventoryIcon from '@/assets/svg/InventoryIcon.vue';
import EditIcon from '@/assets/svg/EditIcon.vue';
import DocumentIcon from '@/assets/svg/DocumentIcon.vue';
import ModalImage from '@/components/modal/confirm-form-modal.vue'
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';


import axios from 'axios';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { hasAnyRole, isAdsUser, isBackOffice } from '@/services/userRoles';

const { t } = useI18n();

const showInventory = hasAnyRole(['admin', 'superadmin']);
// Las noticias del Inicio las publica cualquier perfil interno de ADS, no solo
// el responsable (ADS-0133).
const canPublishNews = isAdsUser();
// El resumen global de solicitudes sigue siendo solo del responsable.
const isSuperadmin = hasAnyRole(['superadmin']);
// Back Office resume y abre solo sus solicitudes asignadas; Alexandra y Paola
// conservan la vista global de toda la plataforma (ADS-0113).
const ownRequestsOnly = isBackOffice();

// Mismos límites que valida la API en AdminController::create_notice: así el
// aviso explica el motivo antes de subir nada (ADS-0133).
const NEWS_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif'];
const NEWS_IMAGE_MAX_MB = 5;
const NEWS_IMAGE_MAX_BYTES = NEWS_IMAGE_MAX_MB * 1024 * 1024;

const TOAST_OPTIONS = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const isModalOpen = ref(false);
const selectedImage = ref(null)
const imageFile = ref(null)

const openModal = () => {
  if (!canPublishNews) return;
  isModalOpen.value = true;
};

const closeModal = () => {
  isModalOpen.value = false;
};

const handleImageSelected = (file) => {
  imageFile.value = file;
}

// La API rechaza otros formatos y cualquier imagen por encima del máximo, así
// que se avisa del motivo antes de enviarla: hasta ahora solo salía un error
// sin explicación y no se podía corregir (ADS-0133).
const newsImageError = (file) => {
  if (!NEWS_IMAGE_TYPES.includes(file.type)) return t('toast.image_format');
  if (file.size > NEWS_IMAGE_MAX_BYTES) return t('toast.image_too_large', { max: NEWS_IMAGE_MAX_MB });
  return null;
};

const uploadErrorMessage = (error) => {
  const status = error.response?.status;
  // El servidor corta por tamaño antes de llegar a la validación de la API.
  if (status === 413) return t('toast.image_too_large', { max: NEWS_IMAGE_MAX_MB });
  if (status === 403) return t('toast.upload_forbidden');
  return t('toast.upload_error');
};

const buttons = [
  { text: "Cancelar", action: () => {
    closeModal();
    selectedImage.value = null;
    imageFile.value = null;
  }, class: "bg-gray-300 text-gray-700 hover:bg-gray-400" },
  {
    text: "Subir imagen",
    async action() {
      if (!canPublishNews) return;
      if (!imageFile.value) {
        toast.warning(t('toast.select_image'), TOAST_OPTIONS);
        return;
      }

      const invalidImage = newsImageError(imageFile.value);
      if (invalidImage) {
        toast.error(invalidImage, TOAST_OPTIONS);
        return;
      }

      try {
        const formData = new FormData();
        formData.append('img', imageFile.value);
        formData.append('title', 'noticia');

        const response = await axios.post(
          `${import.meta.env.VITE_API_URL}/notice/create`,
          formData,
          {
            headers: {
              // Sin esto la API contesta con una redirección HTML en vez del
              // error en JSON, y el motivo del fallo se perdía (ADS-0133).
              'Accept': 'application/json',
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );

        // Si la respuesta es exitosa (201 Created)
        if (response.status === 201) {
          // Actualizar las imágenes localmente
          const newImage = {
            id: response.data.value.id,
            url: buildNoticeImageUrl(response.data.value.img),
            title: response.data.value.title,
            img: response.data.value.img,
            created_at: response.data.value.created_at,
            updated_at: response.data.value.updated_at
          };

          images.value.unshift(newImage);

          closeModal();
          selectedImage.value = null;
          imageFile.value = null;

          toast.success(t('toast.upload_success'), { ...TOAST_OPTIONS, autoClose: 2000 });

          // Recargar las imágenes para asegurar consistencia
          await getNoticeFetch();
        }
      } catch (error) {
        console.error('Error al subir la imagen:', error);
        if (error.response) {
          console.error('Error response:', error.response.data);
        }
        toast.error(uploadErrorMessage(error), TOAST_OPTIONS);
      }
    },
    class: "bg-[#3EC5E6] text-white"
  }
]

const items = ref({
  total_requests: 0,
  total_properties: 0,
  total_estates: 0,
  total_light: 0,
  total_gas: 0,
  total_users: 0,
  total_invoicces: 0
});

const images = ref([])

const buildNoticeImageUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;

  const imageBaseUrl = import.meta.env.VITE_API_IMG?.replace(/\/$/, '');
  const cleanPath = String(path).replace(/^\/+/, '');

  return `${imageBaseUrl}/${cleanPath}`;
};

const fetchDataFromApi = async () => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/stats/inventory`,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      }
    );
    console.log(response.data.value)
    if (response.data?.value) {
      console.log('axios stats', response.data.value)
      Object.keys(items.value).forEach(key => {
        items.value[key] = response.data.value[key] || 0;
      });
      console.log(items);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

const getNoticeFetch = async () => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/home/notices/get?per_page=100`,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      }
    );
    console.log('Notices response', response.data);

    if (Array.isArray(response.data.value.data)) {
      images.value = response.data.value.data
        .map(item => ({
          id: item.id,
          url: buildNoticeImageUrl(item.img),
          title: item.title,
          img: item.img,
          created_at: item.created_at,
          updated_at: item.updated_at
        }))
        .filter(item => item.url);
      console.log('Images cargadas:', images.value);
    }
  } catch (error) {
    images.value = [];
    console.error('Error fetching notices:', error);
  }
};

const handleDeleteImage = async (idOrIndex) => {
  if (!canPublishNews) return;
  try {
    console.log('ID o índice recibido:', idOrIndex);
    console.log('Lista actual de imágenes:', images.value);

    // Primero intentamos encontrar por ID
    let noticeIndex = images.value.findIndex(item => item.id === idOrIndex);

    // Si no encontramos por ID, asumimos que es un índice
    if (noticeIndex === -1) {
      noticeIndex = idOrIndex;
      if (noticeIndex < 0 || noticeIndex >= images.value.length) {
        console.error('Índice inválido:', noticeIndex);
        return;
      }
    }

    const imageToDelete = images.value[noticeIndex];
    console.log('Imagen a eliminar:', imageToDelete);

    if (!imageToDelete || !imageToDelete.id) {
      console.error('No se encontró la imagen o no tiene ID');
      return;
    }

    console.log('Eliminando imagen con ID:', imageToDelete.id);
    await axios.delete(
      `${import.meta.env.VITE_API_URL}/notice/delete/${imageToDelete.id}`,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Accept': 'application/json',
        }
      }
    );

    // Quitar del array local
    images.value.splice(noticeIndex, 1);
    console.log('Imagen eliminada. Nueva lista:', images.value);

    toast.success("Imagen eliminada exitosamente", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } catch (error) {
    console.error('Error al eliminar la imagen:', error);
    console.error('Detalles del error:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    toast.error("Error al eliminar la imagen", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

const fetchStats = async () => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}${isSuperadmin ? '/stats/superadmin/requests' : '/stats/user'}`,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    console.log(response)
    if (response.data?.value) {
      const stats = response.data.value;
      let total = stats.reduce((sum, item) => sum + Number(item.total), 0);

      // Calcular porcentajes
      requestStats.value = {
        nuevas: stats.find(item => item.status === 'created')?.total || 0,
        en_progreso: stats.find(item => item.status === 'review')?.total || 0,
        pendientes: stats.find(item => item.status === 'pending')?.total || 0,
        cerradas: stats.find(item => item.status === 'results')?.total || 0,
        canceladas: stats.find(item => item.status === 'cancel')?.total || 0,
        total: total
      };

      // Calcular porcentajes
      requestStats.value.porcentajeNuevas = total > 0 ? ((requestStats.value.nuevas / total) * 100).toFixed(1) : 0;
      requestStats.value.porcentajeEnProgreso = total > 0 ? ((requestStats.value.en_progreso / total) * 100).toFixed(1) : 0;
      requestStats.value.porcentajePendientes = total > 0 ? ((requestStats.value.pendientes / total) * 100).toFixed(1) : 0;
      requestStats.value.porcentajeCerradas = total > 0 ? ((requestStats.value.cerradas / total) * 100).toFixed(1) : 0;
      requestStats.value.porcentajeCanceladas = total > 0 ? ((requestStats.value.canceladas / total) * 100).toFixed(1) : 0;
    }

  } catch (error) {
    console.error('Error fetching stats:', error);
  }
};

// Agregar requestStats al estado
const requestStats = ref({
  nuevas: 0,
  en_progreso: 0,
  pendientes: 0,
  cerradas: 0,
  canceladas: 0,
  total: 0,
  porcentajeNuevas: 0,
  porcentajeEnProgreso: 0,
  porcentajePendientes: 0,
  porcentajeCerradas: 0,
  porcentajeCanceladas: 0
});

onMounted(async () => {
  await Promise.all([fetchStats(), getNoticeFetch(), ...(showInventory ? [fetchDataFromApi()] : [])]);
});

</script>

<style scoped>
/* En pantallas <= 915px apilar las columnas y poner el estado debajo */
@media (max-width: 1024px) {
  .client-dashboard-grid {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}

/* Más espacio para los botones en pantallas pequeñas */
@media (max-width: 1175px) {
  .button-list {
    width: 100%;
  }

  .button-list > a {
    display: block;
  }

  /* Asegurar que los botones ocupen el ancho disponible y tengan más altura táctil */
  .button-list > a > * {
    width: 100%;
    min-width: 0;
  }
}
</style>
